import { render, staticRenderFns } from "./ShowAnexo.vue?vue&type=template&id=84c7b5fe&lang=pug&"
import script from "./ShowAnexo.vue?vue&type=script&lang=js&"
export * from "./ShowAnexo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports